import indexGetters from "./indexStore/getters";
// 公有内容直接写入。
var getters = {
    ...indexGetters
};
export default getters;